import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import isEmpty from 'lodash/isEmpty';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

import ProductCardCarousel from 'Components/HomePage/ProductCardCarousel';
import RecommendationsCarousel3Panel from 'Components/Carousel/RecommendationsCarousel3Panel';

const Recommendations = ({
  hits,
  title,
  lightTheme,
  slidesToShow,
  lazyLoadCover,
  franchises,
  hitCardNameTag,
  headingTag: HeadingTag,
  hideTitle,
  productPage,
  sliderSettings,
}) => {
  let relatedLink;
  let relatedName;

  if (franchises && franchises.length) {
    const hasRelated = franchises.find(f => f.hasRelated);

    if (hasRelated) {
      relatedLink = `/games-like/${hasRelated.slug}`;
      relatedName = hasRelated.name;
    }
  }

  let sectionTitle = <FormattedMessage id="recommendations.title" defaultMessage="You may also like" />;
  if (title) sectionTitle = title;
  if (relatedLink) sectionTitle = <FormattedMessage id="recommendations.games-like-title" defaultMessage="Games like {gameName}" values={{ gameName: relatedName }} />;

  const useLargeCardCarousel = productPage;

  return (
    <section className={classNames('Recommendations recommendation-container', { 'recommendation-container-carousel-padding': !productPage }, { 'page-section-margin with-dots': productPage })}>
      {!hideTitle &&
        <div className="title-tabs-container mb-4">
          <div className="title-container d-flex align-items-center">
            <HeadingTag className="section-title m-0">
              {sectionTitle}
            </HeadingTag>
            {!isEmpty(hits) && relatedLink &&
              <Link to={relatedLink} className="view-all-btn btn btn-outline-primary btn-sm">
                <FormattedMessage id="recommendations.button.view-all" defaultMessage="View all games" />
              </Link>
            }
          </div>
        </div>
      }

      {useLargeCardCarousel &&
        <RecommendationsCarousel3Panel hitData={hits} />
      }

      {!useLargeCardCarousel &&
        <ProductCardCarousel
          resetCarousel
          showFakeCards
          hitData={hits}
          sliderLightTheme={lightTheme}
          slidesToShow={slidesToShow}
          lazyLoadCover={lazyLoadCover}
          hitCardNameTag={hitCardNameTag}
          sliderSettings={sliderSettings}
        />
      }
    </section>
  );
};

Recommendations.propTypes = {
  hits: PropTypes.array,
  title: PropTypes.string,
  lightTheme: PropTypes.bool,
  slidesToShow: PropTypes.number,
  lazyLoadCover: PropTypes.bool,
  hitCardNameTag: PropTypes.string,
  headingTag: PropTypes.string,
  hideTitle: PropTypes.bool,
  productPage: PropTypes.bool,
  sliderSettings: PropTypes.shape({}),
};

Recommendations.defaultProps = {
  hits: [],
  title: '',
  lightTheme: false,
  slidesToShow: 4,
  lazyLoadCover: true,
  hitCardNameTag: 'div',
  headingTag: 'h2',
  hideTitle: false,
  productPage: false,
  sliderSettings: {},
};

export default Recommendations;
